/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Flex, Text } from '@chakra-ui/react';
import { CategoryItem, DataTable } from './TableQuantitatives.types';
import { formatValue } from '../../../../utils/formatValue';
import { useQuantitatives } from '../../../../contexts/QuantitativesContext';

interface TableQuantitativesProps {
  data: any;
}

export function TableQuantitatives({ data }: TableQuantitativesProps) {
  const { measures } = useQuantitatives();
  const allNames = Object.keys(data);

  const firstData: DataTable = data[allNames[0]].quant[0];

  const tableHeaders = Object.values(firstData).map((category) => ({
    label: category.label,
    typeValue: category.typeValue || '',
  }));

  const area = formatValue(data.area);

  return (
    <TableContainer w="100%">
      <Table variant="simple">
        <Thead bgColor="#F4F4F4" color="#667085" border="1px solid #EDEDED">
          <Tr bgColor="white">
            <Th />
            <Th textTransform="none" padding="8px 8px 8px 4px">
              <Flex>
                <Text color="#071E24" fontSize="14px" fontWeight="700">
                  Área:&nbsp;
                  <Text as="span" color="#071E24" fontSize="14px" fontWeight="500">
                    {area} m² -
                  </Text>
                </Text>
                <Text fontSize="12px" color="#071E24" fontWeight="500">
                  &nbsp;{measures.largura}m
                  <Text as="span" fontSize="12px" color="#A0AEC0" fontWeight="500">
                    (L)
                  </Text>
                  &nbsp;X {measures.comprimento}m
                  <Text as="span" fontSize="12px" color="#A0AEC0" fontWeight="500">
                    (C)
                  </Text>
                </Text>
              </Flex>
            </Th>
            <Th />
            <Th />
            <Th />
            <Th />
            <Th />
          </Tr>
          <Tr css={{ '& > *:not(:last-of-type)': { borderRight: '1px solid #dee5e6' } }}>
            {tableHeaders.map((header, index) => (
              <Th key={index} textTransform="unset" fontSize="14px" padding="8px 8px 8px 4px">
                <Flex flexDir="column">
                  <Text color="#667085">{header.label}</Text>
                  {header.typeValue && <Text color="#667085">({header.typeValue})</Text>}
                </Flex>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody
          css={{
            'tr:nth-of-type(even) td': { backgroundColor: '#f4f4f4' },
            'td:not(:last-of-type)': { borderRight: '1px solid #dee5e6' },
            td: { padding: '8px 8px 8px 4px' },
          }}
        >
          {allNames.map(
            (name, Index) =>
              Index === 0 && (
                <React.Fragment key={Index}>
                  <Tr>
                    <Td />
                    <Td color="#071E24" fontSize="14px" fontWeight="700">
                      {data[name].label}
                    </Td>
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                  </Tr>
                  {data[name].quant.map((category, index) => (
                    <Tr
                      key={index}
                      css={{
                        'td:last-child > p:last-child': {
                          textAlign: 'end',
                        },
                      }}
                    >
                      {Object.values<CategoryItem>(category).map((item, indexItem) => (
                        <Td key={indexItem} maxW="10rem">
                          <Text fontSize="14px" whiteSpace="normal">
                            {item.value}
                          </Text>
                        </Td>
                      ))}
                    </Tr>
                  ))}
                  {data[name].totais && (
                    <Tr borderBottom="none">
                      <Td />
                      <Td color="#071E24" fontWeight="700" fontSize="14px">
                        Totais:{' '}
                      </Td>
                      <Td />
                      <Td />
                      <Td />
                      <Td>
                        <Flex flexDir="column">
                          {data[name].totais.map((category, index) => (
                            <React.Fragment key={index}>
                              {Object.values<CategoryItem>(category).map((item, indexItem) => (
                                <Flex key={indexItem} fontSize="14px" flexDirection="row" gap="2px">
                                  <Text fontWeight={700}> {item.label} </Text>
                                  <Text>
                                    {item.value ? `${item.value} ${item.typeValue || ''}` : '-'}
                                  </Text>
                                </Flex>
                              ))}
                            </React.Fragment>
                          ))}
                        </Flex>
                      </Td>
                      <Td />
                    </Tr>
                  )}
                </React.Fragment>
              ),
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
